export default __webpack_public_path__ + "static/media/grubhub.9e3a78a7.png";